import { render, staticRenderFns } from "./FacilityItem.vue?vue&type=template&id=04f1ac28&"
import script from "./FacilityItem.vue?vue&type=script&lang=js&"
export * from "./FacilityItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports